<template>
  <TitleWrapper
    :filter-option="true"
    title="ALLUSR"
    tooltip-title="ALLUSR"
    :display-breadcrumb="true"
    :displayed-column-options="csvFilterOptions"
    :already-selected-displayed-column="filtersPayload.displayedColumns"
    :count="filtersCount"
    @cancel="cancelHanlder"
    @applyFilter="emitFiltersPayload($event, invalid)"
    @clear="clearFilters"
  >
    <template v-slot:filterItems>
      <InputFieldWrapper layout-mode="true">
        <UiInput
          v-model.trim="filtersPayload.first_name"
          class="flex-1"
          title="First Name"
          type="text"
          placeholder="SEARCH_BY_FNAME"
          rules="alpha_spaces"
          :filter="FILTERS_LIST.FIRST_NAME"
          @emitQuery="updateQuery"
        ></UiInput>
        <UiInput
          v-model.trim="filtersPayload.last_name"
          class="flex-1"
          title="Last Name"
          type="text"
          placeholder="SEARCH_BY_LNAME"
          rules="alpha_spaces"
          :filter="FILTERS_LIST.LAST_NAME"
          @emitQuery="updateQuery"
        ></UiInput>
        <UiMultiSelectBox
          v-model="filtersPayload.role_ids"
          label="title"
          reduce="value"
          :options="userRolesList"
          title="ROLE"
          :already-selected="selectedRoles"
          class="flex-1 mb-5 sm:mb-0"
          :filter="FILTERS_LIST.MYQAMPUS_ROLES"
          input-color="bg-white"
          @emitQuery="updateQuery"
        />
        <UiInput
          v-model.trim="filtersPayload.phone"
          title="Phone Number"
          placeholder="Phone Number"
          class="flex-1"
          :filter="FILTERS_LIST.PHONE"
          @emitQuery="updateQuery"
        />
        <UiInput
          v-model.trim="filtersPayload.email"
          class="flex-1"
          title="Email"
          placeholder="Email"
          :filter="FILTERS_LIST.EMAIL"
          @emitQuery="updateQuery"
        />
        <UiSingleSelect
          v-model.trim="filtersPayload.gender"
          title="Gender"
          :options="GENDERS"
          input-color="bg-white"
          class="flex-1"
          label="title"
          reduce="value"
          :filter="FILTERS_LIST.GENDER"
          @emitQuery="updateQuery"
        />
        <UiDatePicker
          v-model="filtersPayload.date_of_birth_after"
          title="DOB_GT"
          class="flex-1"
          :filter="FILTERS_LIST.DATE_OF_BIRTH_GREATER_THAN"
          @change="birthDateAfter"
          @emitQuery="updateQuery"
        />
        <UiDatePicker
          v-model="filtersPayload.date_of_birth_before"
          title="DOB_LT"
          class="flex-1"
          :filter="FILTERS_LIST.DATE_OF_BIRTH_LESS_THAN"
          @change="birthDateBefore"
          @emitQuery="updateQuery"
        />
        <UiSingleSelect
          v-model.trim="filtersPayload.login_enabled"
          title="STATUS"
          :options="LOGIN_ENABLED_STATUSES"
          input-color="bg-white"
          class="flex-1"
          label="title"
          reduce="value"
          :filter="FILTERS_LIST.LOGIN_ENABLED_STATUS"
          @emitQuery="updateQuery"
        />
      </InputFieldWrapper>
    </template>
  </TitleWrapper>
</template>

<script>
import UiInput from '@components/UiElements/UiInputBox.vue'
import UiSingleSelect from '@/src/components/UiElements/UiSingleSelect.vue'
import TitleWrapper from '@components/TitleWrapper.vue'
import UiMultiSelectBox from '@src/components/UiElements/UiMultiSelect.vue'
import { ROLES_LIST } from '@src/constants/user-roles-constants.js'
import filterMixins from '@/src/mixins/filter-mixins.js'
import UiDatePicker from '@components/UiElements/UiDatePicker.vue'
import { USER_CONSTANTS } from '@src/constants/general-constants'
import { mapState, mapActions } from 'vuex'
import { FILTERS_LIST } from '@src/constants/filter-constants.js'
import { fullName } from '@src/utils/settings/tenant-user.util.js'
import { objectDeepCopy, getCountFromObject } from '@utils/generalUtil'
import InputFieldWrapper from '@/src/components/UiElements/InputFieldWrapper.vue'

export default {
  components: {
    UiSingleSelect,
    TitleWrapper,
    UiDatePicker,
    UiMultiSelectBox,
    UiInput,
    InputFieldWrapper,
  },
  mixins: [filterMixins],
  props: {
    csvFilterOptions: {
      type: Array,
      default: () => [],
    },
    alreadySelectedDisplayedColumns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ROLES_LIST,
      $where: {},
      FILTERS_LIST,
      userRolesList: [],
      filtersCount: 0,
      selectedRoles: [],
      forceRender: 0,
      appliedQueries: {},
      GENDERS: USER_CONSTANTS.GENDERS,
      LOGIN_ENABLED_STATUSES: USER_CONSTANTS.LOGIN_ENABLED_STATUSES,
      dashboard: 'dashboard',
      filtersPayload: {
        login_enabled: '',
        first_name: '',
        last_name: '',
        gender: '',
        role_ids: [],
        email: '',
        phone: '',
        date_of_birth_before: '',
        date_of_birth_after: '',
        displayedColumns: [],
      },
    }
  },
  computed: {
    ...mapState({
      currentSectionScope: (state) => state.layout.currentSectionScope.id,
      currentCampusScope: (state) => state.layout.currentCampusScope || null,
    }),
  },
  watch: {
    currentCampusScope: {
      handler() {
        this.clearFilters()
      },
    },

    currentSectionScope: {
      handler() {
        this.clearFilters()
      },
    },
  },
  mounted() {
    this.updateDisplayedColumnList()
    this.userRolesList = this.ROLES_LIST
  },

  methods: {
    getFiltersCount() {
      this.getSelectedRoles()
      return getCountFromObject(this.filtersPayload, 'displayedColumns', 'boolean')
    },
    getSelectedRoles() {
      let alreadySelectedRoles = []
      this.userRolesList.forEach((role) => {
        if (this.filtersPayload && this.filtersPayload.role_ids.length) {
          this.filtersPayload.role_ids.forEach((value) => {
            if (role.value === value) alreadySelectedRoles.push(role)
          })
        }
        this.selectedRoles = alreadySelectedRoles
      })
    },
  },
}
</script>
